import bilAPI from "./api";

// The review of a question (ТЗ 3.2): its status steps, its author's resubmit and its deletion. The question page
// reads what the user may do now from the detail's `actions` ({edit, delete, resubmit, missing, transitions,
// comment_required}); the backend checks every step again.
const json = { headers: { "Content-Type": "application/json" } };

// A step of actions.transitions: `status` is the target status's uuid (question_statuses/ by code). A comment
// is sent only when there is one (never the old "no comment"); `confirm` repeats a return that a 409
// question_in_tests asked about. Answers with the history record of the change.
export const changeQuestionStatus = (uuid, { status, comment, confirm } = {}) =>
  bilAPI
    .post(
      `/questions/questions/${uuid}/update_status/`,
      { status, ...(comment ? { comment } : {}), ...(confirm ? { confirm: true } : {}) },
      json
    )
    .then((res) => res.data);

// Its author sends a question returned for changes (CHANGES_REQUESTED) to review again (RESUBMITTED).
// 400 incomplete + missing says what it still lacks.
export const resubmitQuestion = (uuid, { comment } = {}) =>
  bilAPI.post(`/questions/questions/${uuid}/resubmit/`, comment ? { comment } : {}, json).then((res) => res.data);

// 403 edit_locked: not at this stage; 409 question_in_use: someone else has had it already.
export const deleteQuestionByUUID = (uuid) =>
  bilAPI.delete(`/questions/questions/${uuid}/`).then((res) => res.data);
